// back_button_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    console.log('Back controller connected');
    if (window.history.length > 1) {
      this.element.style.display = 'block';
    }
  }

  goBack() {
    console.log('Back button clicked');
    window.history.back();
  }
}
